import { Experiences } from '@/src/experiences'

export default Experiences.CardPayments.Screens.AutoPaySuccess.Screen
